import React from 'react';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/constants';
import VariantFilter from '@/components/vehicle-variant-filter';
import VehicleVariantList, { type VehicleVariantOption } from '@/components/vehicle-variant-list';
import { type HsiycSearchVehiclesRecord } from '@/types/legacy-api/graphql';

const StyledDivider = styled(Divider)`
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    margin-top: 0;
  }

  &.MuiDivider-root {
    border-width: 1px;
  }
`;

type DynamicVariantFiltersProps = {
  filters?: {
    label?: string;
    options?: VehicleVariantOption[];
    selectedOption?: VehicleVariantOption;
  }[];
  onChange(...args: unknown[]): unknown;
  isFullWidth?: boolean;
  allVehicles: HsiycSearchVehiclesRecord[];
};

const DynamicVariantFilters = ({
  filters = [],
  allVehicles,
  onChange,
  isFullWidth = false,
}: DynamicVariantFiltersProps) => {
  return (
    <>
      {filters.map(({ label, options, selectedOption }, index) => {
        const props = {
          label,
          options,
          allVehicles,
          selectedOption,
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'event' implicitly has an 'any' type.
          onChange: (event, item) => onChange({ ...event, filterLabel: label }, item, index),
        };
        return label === 'Vehicle Description' ? (
          <React.Fragment key={label}>
            {filters.length > 1 && <StyledDivider />}
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: any; options: any; allVehicles: any; selectedOption: any; onChange: (event: any, item: any) => any; }' is not assignable to type 'VehicleVariantListProps'. */}
            <VehicleVariantList {...props} />
          </React.Fragment>
        ) : (
          <VariantFilter {...props} key={label} isFullWidth={isFullWidth} />
        );
      })}
    </>
  );
};

export default DynamicVariantFilters;
